/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 * 
 */

let baseUrl = ''; 
let routerMode = 'hash'


if (process.env.NODE_ENV == 'development') {
  baseUrl = '';

}else if(process.env.NODE_ENV == 'productionTest'){

	 baseUrl = 'http://api.anxin180.com';
  
}else if(process.env.NODE_ENV == 'productionPre'){

	baseUrl = 'https://uat-api.51anxintou.com';
	// /
 
}else if(process.env.NODE_ENV == 'production'){

	baseUrl = 'https://api.51anxintou.com';
	// /
 
}

export {
	baseUrl,
	routerMode,
}


// WEBPACK FOOTER //
// ./src/config/env.js